export default "__VITE_ASSET__aiiqxISr__"